import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const FormFooter = props => {
  const { url, reference, hideBackButton, labelSaveButton } = props;
  return (
    <div className="row">
      <div className="container-fluid">
        {!hideBackButton && (
          <Link to={url}>
            <button type="button" className="btn btn-success">
              Voltar
            </button>
          </Link>
        )}
        <button
          type="submit"
          ref={reference}
          className="btn btn-primary float-right"
        >
          {labelSaveButton || 'Salvar'}
        </button>
      </div>
    </div>
  );
};

FormFooter.propTypes = {
  url: PropTypes.string,
  reference: PropTypes.object,
  hideBackButton: PropTypes.bool,
  labelSaveButton: PropTypes.string
};

export default FormFooter;
